module.exports = __webpack_public_path__ + "static/img/interview-1-4.e2706b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/interview-1-4.png
// module id = beTk
// module chunks = 1